import styled from '@emotion/styled'

export const BannerHeader = styled.h1`
  label: BannerHeader;
  margin-bottom: 20px !important;
  text-align: left;
  color: #fff !important;
  @media (max-width: 719px) {
    line-height: 32px;
  }
`

export const ViewPDFDiv = styled.div`
  label: ViewPDFDiv;
  display: flex;
  justify-content: end;
  @media (max-width: 719px) {
    display: inline;
    justify-content: inherit;
  }
`
